// @flow

class ActiveSidebar {
    el: HTMLElement;
    items: Array<HTMLElement>;
    constructor(el: HTMLElement) {
        this.el = el;
        this.items = Array.from(
            el.querySelectorAll(".sidebar-menu__item--active")
        );
        let elements = [];
        this.items.forEach((element: any) => {
            elements.push(element);
        });

        const lastEl = elements[elements.length - 1];
        if (lastEl) {
            lastEl.classList.add("submenu-last-active");
            const lastElA = lastEl.querySelector("a");
            if (lastElA) {
                lastElA.classList.add("submenu-last-active");
            }
        }
    }
}

const els = document.querySelectorAll(".content-sidebar");
els.forEach((el: HTMLElement) => {
    new ActiveSidebar(el);
});
